export default "__VITE_ASSET__BC4bQG3G__"